<template>
  <AppTableControl
    no-filter
    no-export
    @query-debounced="searchQuery"
  ></AppTableControl>
</template>

<script>
import AppTableControl from "@/modules/core/components/shared/filter/AppTableControl";
export default {
  name: "SchoolAwayDetailTableControl",
  components: { AppTableControl },
  beforeDestroy() {
    this.$store.dispatch("changeSchoolAwayDetailListBaseFilter", {
      query: null,
    });
  },
  methods: {
    /**
     * Search query
     *
     * @param query
     */
    searchQuery(query) {
      console.log(query);

      this.$store.dispatch("changeSchoolAwayDetailListBaseFilter", { query });

      this.$store.dispatch("fetchSchoolAwayDetailList");
    },
  },
};
</script>

<style scoped></style>
